import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import SuggestedServicesErrorScreen from './SuggestedServicesErrorScreen';
import ServiceListStore from '../../common/stores/ServiceList';
import { getSuggestedServices, setSelectedService } from '../actions/ServiceList';
import { UX2 } from '@wsb/guac-widget-core';
import SuggestedServicesLoader from './SuggestedServicesLoader';
import routes from '../../constants/routes';
import { trackC1 } from '../utils/trackMetric';
import * as MetricsEvents from '../constants/metrics';
import { Duration as LuxonDuration } from 'luxon';
import ConfigStore from '../../common/stores/Config';

const SuggestedServices = props => {
  const { widgetId, router, staticContent } = props;
  const { Card } = UX2.Group;
  const { Block, Label, Text, Heading, Button } = UX2.Element;
  const configState = ConfigStore.getState();
  const { currency_format: { symbol: currencySymbol } = {} } = configState;
  const { suggestedServices, isFetchingSuggestedServices, error, selectedSuggestedService } =
    ServiceListStore.getState();
  const { services = [] } = suggestedServices;
  useEffect(() => {
    if (services && services.length === 0) {
      getSuggestedServices();
    }
  }, []);

  if (isFetchingSuggestedServices) {
    return <SuggestedServicesLoader staticContent={ staticContent } />;
  }

  /**
   * Formats a Luxon duration object into a human-readable string.
   * @param {string} isoDuration - The ISO duration string.
   * @returns {string} The formatted duration string.
   */
  const formatDuration = isoDuration => {
    const { days, hours, minutes } = LuxonDuration.fromISO(isoDuration);

    let durationString = '';

    if (days) {
      durationString += `${days} day${days > 1 ? 's' : ''} `;
    }
    if (hours) {
      durationString += `${hours} hour${hours > 1 ? 's' : ''} `;
    }
    if (minutes) {
      durationString += `${minutes} minute${minutes > 1 ? 's' : ''}`;
    }

    return durationString.trim();
  };

  const openUrl = (event, service) => {
    event.stopPropagation();
    trackC1(MetricsEvents.APPOINTMENTS_ZERO_STATE_ADD_RECOMMENDED_SERVICES_CTA_CLICK);
    router.updateRoute({ widget: widgetId, route: '/' });
    setTimeout(() => {
      setSelectedService(service);
      router.updateRoute({
        widget: widgetId,
        route: routes.SERVICES_DETAILS,
        params: { serviceId: service.service_id }
      });
    }, 0);
  };

  return (
    <Block
      style={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column'
      }}
    >
      <Label
        style={{
          fontSize: '24px',
          fontWeight: 'bold',
          marginBottom: '20px',
          maxWidth: '700px'
        }}
      >
        { staticContent.recommendServiceHeader ||
          'Boost Your Business: Add The Recommended Service to Accelerate Business Growth' }
      </Label>
      { services.length === 0 || error ? (
        <SuggestedServicesErrorScreen staticContent={ staticContent } />
      ) : null }
      { services && services.length
        ? services.map(service => (
          <Card
            key={ service.service_id }
            style={{
              width: '100%',
              display: 'flex',
              flex: 1,
              alignItems: 'center',
              paddingLeft: '20px',
              paddingRight: '20px',
              borderRadius: '7px',
              border: '1px solid #000',
              background: '#f5f5f5',
              minHeight: '70px',
              marginBottom: '10px',
              maxWidth: '600px',
              backgroundColor:
                  selectedSuggestedService.service_name === service.service_name
                    ? '#d8efef'
                    : 'white'
            }}
          >
            <Block
              style={{
                width: '100%',
                display: 'flex',
                flex: 2,
                flexDirection: 'column',
                alignItems: 'flex-start'
              }}
            >
              <Heading>{ service.service_name }</Heading>
              <Text style={{ textTransform: 'capitalize' }}>
                { currencySymbol } { service.price } | { formatDuration(service.duration) }
              </Text>
            </Block>

            <Block
              style={{
                display: 'flex',
                flex: 1,
                justifyContent: 'flex-end'
              }}
            >
              <Button
                style={{
                  color: 'white',
                  backgroundColor: 'black',
                  borderRadius: '5px'
                }}
                size='small'
                design='primary'
                className='btn-blck'
                onClick={ event => {
                  openUrl(event, service);
                } }
              >
                { staticContent.addLabel || 'ADD' }
              </Button>
            </Block>
          </Card>
        ))
        : null }
    </Block>
  );
};

SuggestedServices.propTypes = {
  widgetId: PropTypes.string,
  router: PropTypes.object,
  services: PropTypes.array,
  isFetchingSuggestedServices: PropTypes.bool,
  error: PropTypes.bool,
  selectedSuggestedService: PropTypes.object,
  staticContent: PropTypes.object
};

export default SuggestedServices;
